module.exports = __webpack_public_path__ + "static/media/iconmonstr-cloud-13.74e3fa29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-cloud-13.svg
// module id = 723
// module chunks = 0